(() => {
  const rewardCode = 'UMFRAGE35';
  const rewardParam = 'survey_reward';
  const storageKey = 'mm_survey_reward_v1';
  const legacySessionKey = 'mm_survey_reward_code';
  const rewardLifetimeMs = 24 * 60 * 60 * 1000;

  function safeStorage(storage, action, key, value) {
    try {
      if (action === 'get') return storage.getItem(key);
      storage.setItem(key, value);
    } catch (error) {
      return null;
    }
    return null;
  }

  function persistReward() {
    const payload = JSON.stringify({
      code: rewardCode,
      expiresAt: Date.now() + rewardLifetimeMs,
    });
    safeStorage(window.localStorage, 'set', storageKey, payload);
    safeStorage(window.sessionStorage, 'set', legacySessionKey, rewardCode);
  }

  function hasStoredReward() {
    const legacyCode = safeStorage(window.sessionStorage, 'get', legacySessionKey);
    if (legacyCode === rewardCode) return true;

    const stored = safeStorage(window.localStorage, 'get', storageKey);
    if (!stored) return false;

    try {
      const payload = JSON.parse(stored);
      return payload.code === rewardCode && Number(payload.expiresAt) > Date.now();
    } catch (error) {
      return false;
    }
  }

  function normalizePrice(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function decorateProductPrices(context) {
    if (context.dataset.mmCourseProduct !== 'true') return;

    const regularPrice = normalizePrice(context.dataset.mmRegularPrice);
    const regularPriceWithCurrency = normalizePrice(context.dataset.mmRegularPriceWithCurrency);
    const rewardPrice = normalizePrice(context.dataset.mmRewardPrice);
    if (!regularPrice || !rewardPrice) return;

    const acceptedPrices = new Set([regularPrice, regularPriceWithCurrency]);
    const main = document.getElementById('MainContent');
    if (!main) return;

    const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
    const matchingNodes = [];
    let node = walker.nextNode();
    while (node) {
      if (acceptedPrices.has(normalizePrice(node.nodeValue))) {
        matchingNodes.push(node);
      }
      node = walker.nextNode();
    }

    matchingNodes.forEach((priceNode) => {
      if (!priceNode.parentElement || priceNode.parentElement.closest('[data-mm-survey-price]')) return;

      const presentation = document.createElement('span');
      presentation.className = 'mm-survey-inline-price';
      presentation.dataset.mmSurveyPrice = 'true';

      const original = document.createElement('span');
      original.className = 'mm-survey-inline-price__original';
      original.textContent = regularPrice;

      const reward = document.createElement('span');
      reward.className = 'mm-survey-inline-price__reward';
      reward.textContent = rewardPrice;

      const label = document.createElement('span');
      label.className = 'mm-survey-inline-price__label';
      label.textContent = 'mit Gutschein';

      presentation.append(original, reward, label);
      priceNode.parentNode.replaceChild(presentation, priceNode);
    });

    main.querySelectorAll('.visually-hidden').forEach((label) => {
      if (normalizePrice(label.textContent) === 'Normaler Preis') {
        label.textContent = 'Preis mit aktivem Gutschein';
      }
    });
  }

  function preserveRewardOnShopLinks() {
    document.querySelectorAll('a[href]').forEach((link) => {
      let url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (!url.pathname.startsWith('/products/') && url.pathname !== '/cart') return;

      url.searchParams.set(rewardParam, rewardCode);
      link.href = url.toString();
    });
  }

  function updateCheckoutButtonLabel(button) {
    const label = 'Mit 35 € Rabatt zum Checkout';
    if (button.classList.contains('product-form__submit')) {
      const text = button.querySelector('span');
      if (text) text.textContent = label;
      return;
    }
    button.textContent = label;
  }

  function buildDirectCheckoutConsent(form, index, rewardIsActive) {
    const button = form.querySelector('button[type="submit"][name="add"]');
    if (!button) return null;

    const group = document.createElement('div');
    group.className = 'mm-survey-direct-checkout';
    group.dataset.mmSurveyDirectCheckout = 'true';

    const label = document.createElement('label');
    label.className = 'mm-survey-direct-checkout__consent';

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = `mm-survey-direct-checkout-consent-${index}`;
    checkbox.dataset.mmSurveyDirectCheckoutConsent = 'true';

    const text = document.createElement('span');
    text.append('Ich stimme ausdrücklich zu, dass Mistermestro vor Ablauf der Widerrufsfrist mit der Bereitstellung der digitalen Inhalte beginnt. Mir ist bekannt, dass mein Widerrufsrecht mit Beginn der Ausführung erlischt. Die ');

    const policy = document.createElement('a');
    policy.href = '/policies/refund-policy';
    policy.textContent = 'Widerrufsbelehrung';
    text.append(policy, ' habe ich zur Kenntnis genommen.');

    const error = document.createElement('p');
    error.className = 'mm-survey-direct-checkout__error';
    error.dataset.mmSurveyDirectCheckoutError = 'true';
    error.textContent = 'Bitte bestätige die Zustimmung, bevor du zum Checkout gehst.';
    error.hidden = true;
    error.setAttribute('role', 'alert');

    label.append(checkbox, text);
    group.append(label, error);
    button.parentNode.insertBefore(group, button);
    if (rewardIsActive) updateCheckoutButtonLabel(button);

    return checkbox;
  }

  function setupDirectCheckout(context, rewardIsActive) {
    if (context.dataset.mmCourseProduct !== 'true') return;

    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    const consentCheckboxes = forms
      .map((form, index) => {
        form.dataset.mmSurveyDirectCheckoutForm = 'true';
        return buildDirectCheckoutConsent(form, index, rewardIsActive);
      })
      .filter(Boolean);

    consentCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        consentCheckboxes.forEach((otherCheckbox) => {
          otherCheckbox.checked = checkbox.checked;
          otherCheckbox.removeAttribute('aria-invalid');
          const error = otherCheckbox
            .closest('[data-mm-survey-direct-checkout]')
            ?.querySelector('[data-mm-survey-direct-checkout-error]');
          if (error) error.hidden = true;
        });
      });
    });

    if (rewardIsActive) {
      document.querySelectorAll('[data-mm-mobile-course-cta-button]').forEach(updateCheckoutButtonLabel);
    }

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form[data-mm-survey-direct-checkout-form="true"]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const checkbox = form.querySelector('[data-mm-survey-direct-checkout-consent]');
      const error = form.querySelector('[data-mm-survey-direct-checkout-error]');
      if (!checkbox?.checked) {
        if (error) error.hidden = false;
        checkbox?.setAttribute('aria-invalid', 'true');
        checkbox?.focus();
        return;
      }

      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = Math.max(1, Number.parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10));
      if (!variantId) return;

      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      const checkout = new URL(`/cart/${encodeURIComponent(variantId)}:${quantity}`, window.location.origin);
      if (rewardIsActive) checkout.searchParams.set('discount', rewardCode);
      window.location.assign(checkout.toString());
    }, true);
  }

  const params = new URLSearchParams(window.location.search);
  const arrivedWithReward = params.get(rewardParam) === rewardCode;
  if (arrivedWithReward) persistReward();

  const rewardIsActive = arrivedWithReward || hasStoredReward();
  const context = document.querySelector('[data-mm-survey-reward-journey]');
  if (context) setupDirectCheckout(context, rewardIsActive);

  if (!rewardIsActive) return;
  persistReward();

  document.documentElement.classList.add('mm-survey-reward-active');
  if (context) {
    if (context.dataset.mmPageType !== 'index') context.hidden = false;
    decorateProductPrices(context);
  }
  preserveRewardOnShopLinks();
})();
